// src/routes/PublicRoute.jsx
import { Navigate } from "react-router-dom";
import  useAuthContext from "../context/AuthContext"; 

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuthContext()
  return isAuthenticated ? <Navigate to="/" replace /> : children;
};

export default PublicRoute;
